import { useTranslation } from "react-i18next";
import { useJourneyDynamicDetails, useJourneyStaticDetails } from "../../context";
import useTotalFare from "../../hooks/useTotalFare";
import { formatNumber } from "src/utility";
import SkeletonBox from "src/components/SkeletonBox/SkeletonBox";
import { DashedSeparatorIcon } from "src/assets/Icons";

export default function TotalAmount() {
  const { t } = useTranslation();
  const { journeyDetails } = useJourneyStaticDetails();
  const { payment } = useJourneyDynamicDetails();
  const { totalPrice, pointsFactor, isFetching } = useTotalFare();
  const currency = journeyDetails.data?.fare?.currency ?? "";
  const showSkeleton = isFetching || !payment.selectedPayment;

  return (
    <div className="flex flex-col gap-4 pt-0.5 p-2">
      <span className="text-font-subtle text-xs font-bold uppercase leading-4 tracking-wider">{t("Flights.details.summary.totalAmount")}</span>
      {showSkeleton ? (
        <SkeletonBox className="h-8 w-40" />
      ) : (
        <div className="flex items-center gap-4">
          <span className="whitespace-nowrap text-xl font-bold leading-8 tracking-tight text-font-default">
            {formatNumber(totalPrice)} {currency}
          </span>
          <div className="border-border-disabled flex h-7 w-7 shrink-0 flex-col items-center justify-center -space-y-1 rounded-full border border-dashed bg-background-default">
            <DashedSeparatorIcon className="h-2.5 w-4 text-font-default" />
            <DashedSeparatorIcon className="h-2.5 w-4 text-font-default" />
          </div>
          <span className="text-font-active whitespace-nowrap text-xl font-bold leading-8 tracking-tight">
            {formatNumber(Math.ceil(pointsFactor * totalPrice))} {t("Flights.details.summary.pts")}
          </span>
        </div>
      )}
    </div>
  );
}
